module.exports = __webpack_public_path__ + "media/media/logos/apple-577c73088489066495b8c36718fb7b58.png";